import Flex from "@ui-kit/layout/Flex/Flex.web";
import { MapCanvasProps } from "./MapCanvas.props";

/**
 * Displays the interactive seating map canvas
 */
export default function MapCanvas({ isLoading, canvasId }: MapCanvasProps) {
  return (
    <Flex
      opacity={isLoading ? "0" : "1"} // Opacity is used to hide the map so it's still accessible in the DOM
      width="100%"
      height="100%"
      position="absolute"
      top="none"
      left="none"
    >
      <Flex id={canvasId} width="100%" height="100%" position="relative" />
    </Flex>
  );
}
